import { Component, Inject, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MomService } from 'src/app/service/mom.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
import { I } from '@angular/cdk/keycodes';
import { environment_const, environment_label, environment_msg } from 'src/environments/environment';
import { Globals } from 'src/app/service/global';

@Component({
  selector: 'app-preview-minutes-dialog',
  templateUrl: './preview-minutes-dialog.component.html',
  styleUrls: ['./preview-minutes-dialog.component.css']
})
export class PreviewMinutesDialogComponent implements OnInit {

  private readonly notifier!: NotifierService;
  byteData : any;
  data: any;
  agendaArray:any = [];
  showLoading = false;
  minuteJSON : any;
  momList:any =[];
  isEmptyMomCont:boolean=true;
  generateNewCon:string="N";
  curEditMomFlag:string="Y";
  selectedValue: any="select";
  curMomStatus:any="";
  showSendDraftButton: any;
  showResendDraftButton: any;
  currentMomId: any;
  
  constructor(private permissionService:PermissionService,private utilService:UtilityService,notifierService: NotifierService,public dialog: MatDialog,private globals:Globals,private momService:MomService,protected sanitizer: DomSanitizer,@Inject(MAT_DIALOG_DATA) data: any) {
    this.notifier = notifierService;
    this.data = data ;
    
  }

  ngOnInit(): void {
    this.agendaArray = [];
    this.momList=this.data.momList;
 
    this.selectedValue=this.data.curPkMoMDetailId;
    this.generateNewCon=this.data.generateNewCon;
    this.getCurrentMomStatus();
    // this.data.meetingInfo.agendaList.forEach((ele:any) => {
    //   let tempJSON = {agendaId:""};
    //   tempJSON.agendaId = ele.agendaId;
    //   this.agendaArray.push(tempJSON);
    // });
 
 
    if(this.curMomStatus!=undefined && this.curMomStatus!=environment_const.momApproveStatus){
      this.invokePreviewMinutes();
    }else{
      this.selectedValue="select";
    }
  }
  checkForPreview(){
    if(this.selectedValue!=null && this.selectedValue!=undefined && this.selectedValue!="" && this.selectedValue!="null" && this.selectedValue!="select"){
      this.invokePreviewMinutes();
    }else{
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_select_mom
      });
      $("#previewMinutes").attr("src","");
    }
  }
  isEmptyMomContent(){
    this.isEmptyMomCont=true;
    if(this.momList!=null && this.momList.length>0){
      this.momList.forEach((element:any) => {
        if(element!=null && element.pkMomDetailId==this.selectedValue && element.momContent!=null && element.momContent!=undefined && element.momContent!=""){
          this.isEmptyMomCont=false;
        }
      });
    }
  }
getCurrentMomStatus(){
  if(this.momList!=null && this.momList.length>0){
    var curMomInfo = this.momList.filter((obj:any) => obj.pkMomDetailId == this.selectedValue);
 
    //if(curMomInfo!=null && curMomInfo.length>0)
    if(curMomInfo!=null && curMomInfo.length>0 && curMomInfo[0].momStatusCode!=undefined && curMomInfo[0].momStatusCode!=null){
      this.curMomStatus=curMomInfo[0].momStatusCode;
      if(this.curMomStatus == 'Com'){
        this.showResendDraftButton = this.curMomStatus;
        this.showSendDraftButton = "N";
      }else if(this.curMomStatus== 'Y'){
        this.showResendDraftButton = "N";
        this.showSendDraftButton = this.curMomStatus;
      }
    }
    if(this.generateNewCon!=undefined && this.generateNewCon!=null && this.generateNewCon=="Y"){
      if(curMomInfo!=null && curMomInfo.length>0 && curMomInfo[0].editMomFlag!=undefined && curMomInfo[0].editMomFlag!=null){
        this.curEditMomFlag= curMomInfo[0].editMomFlag;
      }else{
        this.curEditMomFlag="Y";  
      }
    }else{
      this.curEditMomFlag="N";
    }
  }
}

getMomId(momList:any){
  if(momList.momStatusCode == 'Com'){
    this.showResendDraftButton = momList.momStatusCode;
    this.showSendDraftButton = 'N';

  }else{
    this.showSendDraftButton = momList.momStatusCode;
    this.showResendDraftButton = 'N';
  }

}

  invokePreviewMinutes(){
    
    if(this.generateNewCon!=undefined && this.generateNewCon!=null && this.generateNewCon=="Y"){
      this.isEmptyMomCont=false;
    }else{
      this.isEmptyMomContent();
    }
    if(!this.isEmptyMomCont){
      this.constructReq();
      this.showLoading = true;
      this.momService.previewMinutes(this.minuteJSON).subscribe((response)=>{
        let file = new Blob([response], { type: 'application/pdf' });            
        this.byteData = file;
        var blobUrl = URL.createObjectURL(file);
        $("#previewMinutes").attr("src",blobUrl);
        this.showLoading = false;
      })
    }
  }

  constructReq(){
    this.minuteJSON = {
      //  "agendaDetails": "previewAgendaArray:"+JSON.stringify(this.agendaArray),
      //  "approvalHours": 0,
        "deletedFlag": 0,
        //"meetingEndFlag": this.data.meetingInfo.meetingEndFlag,
        //"meetingId": this.data.meetingInfo.meetingId,
        "fkMeetingEntityId": this.data.meetingInfo.meetingId,
        "previewFlag": "Y",
        "reviewType": "RA",
        "orgCode": localStorage.getItem("orgCode"),
        "momStatusCode":"Com",
        "pkMomDetailId":this.selectedValue,
        "userId":localStorage.getItem("userId"),
        "editMomFlag":this.curEditMomFlag,
        "visitorTimeZone":this.globals.vTimeZone,
        "decryptKey": "",
        "categoryId": this.data.meetingInfo.categoryId,
        "minTemplateId": this.data.meetingInfo.minTemplateId
      };
      if(this.data.meetingInfo.isConfidential == 'Y'){
       
        this.minuteJSON.decryptKey = localStorage.getItem("decryptKey");
      }
      return this.minuteJSON;
  }

  sendMoMDraft(){
    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.MINUTES,this.utilService.permissionType.READ);
    
    if(!roleFlag){
      return;
    }
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        dialogTitle : "Confirmation",
        dialogContent : "The MoM will be sent to all participant(s). Please confirm?"
      },
    }).afterClosed().subscribe(response => {
      let dialogResponse = response
      if(dialogResponse == true){
        this.minuteJSON =this.constructReq();
        //this.minuteJSON.sendDraft="Y";
        this.minuteJSON.previewFlag="N";
        //this.invokePreviewMinutes();
        this.showLoading = true;
        this.momService.previewMinutes(this.minuteJSON).subscribe((response)=>{
         
          this.showLoading = false;
          document.getElementById("resetbtn")?.click()
          this.notifier.show({
            type: 'success',
            message: 'The MoM draft has been sent successfully'
          });
        })
        
        
      }
    })
  }

}
